import { Container } from 'react-bootstrap';
import { PricingTable } from '@clerk/clerk-react';

export function PricingPage() {
  return (
    <Container className="mt-5 d-flex justify-content-center">
      <PricingTable />
    </Container>
  );
}
